export default class Popup {
	constructor(parent, custom_html, {gantt}) {
		this.gantt = gantt;
		this.parent = parent;
		this.custom_html = custom_html;
		this.make();
	}

	make() {
		this.parent.innerHTML = `
            <div class="title"></div>
            <div class="subtitle"></div>
        `;

		this.hide();

		this.title = this.parent.querySelector('.title');
		this.subtitle = this.parent.querySelector('.subtitle');
	}

	show(options) {


		if (this.custom_html) {
			this.parent.innerHTML = this.custom_html(options.task);
		} else {
			// set data
			this.title.innerHTML = options.title;
			this.subtitle.innerHTML = options.subtitle;
			this.parent.style.width = this.parent.clientWidth + 'px';
		}

		this.update_pos(options);

		// show
		this.parent.style.visibility = 'visible';

	}

	update_pos(options) {
		if (!options.target_element) {
			throw new Error('target_element is required to show popup');
		}
		if (!options.position) {
			options.position = 'left';
		}
		const target_element = options.target_element;

		// set position
		let position_meta;
		if (target_element instanceof HTMLElement) {
			position_meta = target_element.getBoundingClientRect();
		} else if (target_element instanceof SVGElement) {
			position_meta = options.target_element.getBoundingClientRect();
		}

		let svg_position_meta = this.gantt.$svg.getBoundingClientRect();
		if (options.position === 'left') {
			this.parent.style.left =
				position_meta.x + (position_meta.width) + 'px';
			this.parent.style.top = position_meta.y + 'px';

		}
	}
	hide() {
		this.parent.style.visibility = 'hidden';
		this.parent.style.left = 0;
	}
}
